import $ from 'jquery';

export const init = () => {

	$(window)
		.on('scroll', function () {
			if ($(document).scrollTop() > 30) {
				$('.header').addClass('is-fixed');
			}
			else {
				$('.header').removeClass('is-fixed');
			}
		})
		.trigger('scroll');

};
